// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import ProgressItemStyled from "./ProgressItem.styled";

const ProgressItem = props => {
  const { firstTitle, nextTitle, className, active, hideLast, centerText } = props;
  return (
    <ProgressItemStyled className={className} active={active} centerText={centerText}>
      <div className="hide-mobile firstTitle">{firstTitle}</div>
      <div className="tickMarkFirst"></div>
      {!hideLast && <div className="tickMarkLast"></div>}
      <div className="hide-mobile nextTitle"> {nextTitle} </div>
    </ProgressItemStyled>
  );
};

ProgressItem.propTypes = {
  firstTitle: PropTypes.string,
  nextTitle: PropTypes.string,
  className: PropTypes.string,
  active: PropTypes.bool,
  centerText: PropTypes.bool
};

export default ProgressItem;
